module.exports = __webpack_public_path__ + "static/media/calendar_month_black_24dp.84088d83.svg";